(function () {
  "use strict";

  var form = document.getElementById("pdpForm");
  if (!form) return;

  var productJsonScript = document.getElementById("pdpProductJson");
  var product = null;
  try {
    product = productJsonScript ? JSON.parse(productJsonScript.textContent) : null;
  } catch (e) {
    product = null;
  }

  var selects = Array.prototype.slice.call(form.querySelectorAll(".pdp-option-select"));
  var variantIdInput = document.getElementById("pdpVariantId");
  var priceEl = document.getElementById("pdpPrice");
  var submitBtn = form.querySelector('button[type="submit"]');

  function formatMoney(cents) {
    return "£" + (cents / 100).toFixed(2);
  }

  function currentSelection() {
    return selects.map(function (s) { return s.value; });
  }

  function findVariant(selection) {
    if (!product) return null;
    return product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selection[i]; });
    });
  }

  function onChange() {
    var variant = findVariant(currentSelection());
    if (!variant) return;
    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available
        ? "Add to bag — " + formatMoney(variant.price)
        : "Sold out";
    }
    var img = variant.featured_image && variant.featured_image.src;
    var mainImg = document.getElementById("pdpMainImage");
    if (img && mainImg) mainImg.src = img + "&width=1000";
  }

  selects.forEach(function (s) { s.addEventListener("change", onChange); });

  var thumbs = document.querySelectorAll(".pdp-thumb");
  var mainImage = document.getElementById("pdpMainImage");
  thumbs.forEach(function (t) {
    t.addEventListener("click", function () {
      var full = t.getAttribute("data-full");
      if (full && mainImage) mainImage.src = full;
    });
  });
})();
